import React from 'react'
import routes from '../config/settings/routes'
import BrandLayout from '../components/Layouts/BrandLayout'
import BuyersListContainer from '../containers/BuyersList/BuyersList.container'
import FooterContainer from '../containers/Footer/Footer.container'
import SearchBuyerPanelContainer from '../containers/SearchBuyerPanel/SearchBuyerPanel.container'
import SearchBuyerSectionContainer from '../containers/SearchBuyerSection/SearchBuyerSection.container'
import TopNavbarContainer from '../containers/TopNavbar/TopNavbar.container'
import HomeRegionsContainer from '../containers/HomeRegions/HomeRegions.container'
import HomeMechanismsContainer from '../containers/HomeMechanisms/HomeMechanisms.container'
import HomeHeadingsProductsContainer from '../containers/HomeHeadingsProducts/HomeHeadingsProducts.container'
import PurchasingMechanismsSectionContainer from '../containers/PurchasingMechanismsSection/PurchasingMechanismsSection.container'
import ItemsAndProductsSectionContainer from '../containers/ItemsAndProductsSection/ItemsAndProductsSection.container'
import HomeTradedAmountsContainer from '../containers/HomeTradedAmounts/HomeTradedAmounts.container'
import HomeContainer from '../containers/Home/Home.container'
import HomeBuyerListContainer from '../containers/HomeBuyerList/HomeBuyerList.container'

/**
 * The Home's page.
 */
const Home = () => (
  <BrandLayout footer={<FooterContainer margin="0" />}>
    <TopNavbarContainer menuActive={routes.root} />
    <SearchBuyerPanelContainer />
    <HomeContainer />
    <HomeTradedAmountsContainer />
    <SearchBuyerSectionContainer />
    <HomeBuyerListContainer />
    <BuyersListContainer />
    <HomeRegionsContainer />
    <HomeMechanismsContainer />
    <PurchasingMechanismsSectionContainer />
    <HomeHeadingsProductsContainer />
    <ItemsAndProductsSectionContainer />
  </BrandLayout>
)

export default Home
